import PaymentMethodIcon from './PaymentMethodIcon'

export default PaymentMethodIcon
